require('./myProfileKeysView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @actions
const accessKeyChangeActions = require('actions/accessKeyChange');
const { getKits } = require('actions/myProfileSecurityKitChange');
const { requestDevices, clearDevices } = require('actions/devices');
const myProfileKeysTppsActions = require('actions/myProfileKeysTpps/myProfileKeysTpps');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

// @components
const { ContactInfoBoxCCValidated : ContactInfoBox } = require('components/myProfile/contactInfoBox/contactInfoBox');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const WebappRender = require('components/conditionalRender/webappRender');

// @ utilities
const DateHelper = require('utilities/dateHelper');
const { recordLink } = require('utilities/tagging');

// @ constants
const { FAQ_URL } = require('constants/links');
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { TPP_KEYS_STATUS_ACTIVE } = require('constants/tpps');
const { ECOMMERCE_KEY, FAQ } = require('constants/flagBasedFeatures.js');
const {
    DEVICES_MANAGEMENT,
    DEVICES_TOOLTIP,
    MANAGE_SECURITY,
    MODIFY_SECURITY,
    PASSWORD,
    REGISTRY_SECURITY,
    SECURITY_FAQS,
    SECURITY_PAGE_NAME,
    SECURITY_PERSONALIZATION,
    SIGNATURE_PATTERN,
    TPPS_MANAGEMENT,
} = require("constants/tagging.js");

const infoIcon = require('assets/images/icon-info-blue.svg'); //@hardcoded: replace Icon placeholder
const recentActivityIcon = require('assets/images/myProfileKeys/icon-recent-activity.png');
const securityKitIcon = require('assets/images/myProfileKeys/icon-security-kit.png');
const accessKeyIcon = require('assets/images/myProfileKeys/icon-access-key.png');
const signatureKeyIcon = require('assets/images/myProfileKeys/icon-signature-key.png');
const tppsIcon = require('assets/images/myProfileKeys/icon-tpps.png');
const ecommerceIcon = require('assets/images/myProfileKeys/compra-online.png');


class MyProfileKeysView extends React.Component {
    constructor(props){
        super(props)
        this.renderSecurityKit = this.renderSecurityKit.bind(this);
        this.getLastTPPsActive = this.getLastTPPsActive.bind(this);
    }

    componentWillMount() {
        const {
            getKits,
            requestAccessKeyData,
            requestDevices,
            showSecurityKit,
            showSessionsAndDevices,
            requestTppKeysData
        } = this.props
        requestAccessKeyData();
        showSecurityKit && getKits();
        showSessionsAndDevices && requestDevices(false, null, 1);
        requestTppKeysData();
    }

    componentWillUnmount() {
        const { clearDevices } = this.props;
        clearDevices();
    }

    getLastChangeLabel(lastChange) {
        const { immAccessKeyChange } = this.props;
        const isFetching = immAccessKeyChange.get('isFetching');
        let body;
        if (!isFetching){
            body = lastChange && (
                <div className="row keys-view__last-change-date">
                    <div className="col-md-6">
                        <i className="keys-view__icon-clock"/>
                        <FormattedText
                            className="keys-view__label"
                            value="profileKeysLanding-lastChangeDate"
                            injectedStrings={[lastChange]}
                        />
                    </div>
                </div>
            ) || null;
        }
        return body;
    }

    renderAccessKey(lastChange) {
        const lastChangeDate = DateHelper.getOnlyDateFormatted(lastChange);
        return this.getLastChangeLabel(lastChangeDate)
    }

    renderSignatureKey(lastChange) {
        const lastChangeDate = DateHelper.getOnlyDateFormatted(lastChange);
        return this.getLastChangeLabel(lastChangeDate)
    }

    renderSecurityKit(){
        const { showSecurityKit } = this.props
        const changeSecurityKit = formatText('profileKeysLanding-changeSecurityKit');

        return (
            showSecurityKit ?
                <ContentBox title={changeSecurityKit} smallTitle={true} leftIcon={{'icon': securityKitIcon}}>
                    <FormattedText value="securityKit-changeSecurityKitDesc" className="keys-view__text"/>
                    <div className="keys-view__button">
                        <OKLink
                            modifier="editorial"
                            to="/myprofile/keys/securitykit"
                            onClick={() =>
                            recordLink(
                                SECURITY_PERSONALIZATION,
                                MODIFY_SECURITY,
                                SECURITY_PAGE_NAME
                            )
                        }
                    >
                            <FormattedText value="profileKeysLanding-changeButton" />
                        </OKLink>
                    </div>
                    {this.renderSecurityKitDesc()}
                </ContentBox>
            : null
        )

    }

    renderSecurityKitDesc() {
        const { immMyProfileSecurityKitChange } = this.props;
        const idKit = immMyProfileSecurityKitChange.get('defaultKit');
        return (
            idKit ?
                <div className="row keys-view__security-kit">
                    <div className="col-md-10">
                        <i className="keys-view__icon-padlock"/>
                        <span className="keys-view__label">
                            <span>{formatText('securityKit-changeSecurityKit')}</span>
                            <span>{formatText(`securityKit-selectedKit${idKit}`)}</span>
                        </span>
                    </div>
                </div>
            : null
        )
    }

    renderSessionAndDevicesLabel() {
        const { lastAccess } = this.props;
        return (
            <div
                className="row keys-view__last-change-date"
                onMouseEnter={() =>
                    recordLink(SECURITY_PAGE_NAME, DEVICES_TOOLTIP)
                }
            >
                <div className="col-md-6">
                    <OKTooltip
                        content="profileKeysLanding-tooltipLastAccess"
                        offset={[0, -15]}
                    />
                    <FormattedText
                        value="profileKeysLanding-lastAccess"
                        injectedStrings={[DateHelper.getOnlyDateFormatted(lastAccess)]}
                    />
                </div>
            </div>
        );
    }

    renderSessionAndDevices(){
        const { showSessionsAndDevices } = this.props
        const manageDevicesText = formatText('profileKeysLanding-manageDevices');

        return (
            showSessionsAndDevices ?
                <div className="col-md-12 grid-view--fix-cell-separation">
                    <ContentBox title={manageDevicesText} smallTitle={true} leftIcon={{'icon' : recentActivityIcon}}>
                        <FormattedText value="profileKeysLanding-manageDevicesDesc" className="keys-view__text"/>
                        <div className="keys-view__button">
                            <OKLink
                                modifier="editorial"
                                to="/myprofile/devices"
                                onClick={() =>
                                recordLink(
                                    DEVICES_MANAGEMENT,
                                    REGISTRY_SECURITY,
                                    SECURITY_PAGE_NAME
                                )
                            }
                        >
                                <FormattedText value="profileKeysLanding-manageDevicesButton" />
                            </OKLink>
                        </div>
                        {this.renderSessionAndDevicesLabel()}
                    </ContentBox>
                </div>
            : null
        )
    }

    getLastTPPsActive(){
        const { immProfileKeysTpps } = this.props;
        const listActivesTPPsNames = immProfileKeysTpps.get('tpps').filter(tpps => tpps.get('status') === TPP_KEYS_STATUS_ACTIVE);
        let tppNames = [];
        listActivesTPPsNames.map((tpp) => { tppNames.push(tpp.get('name'));});
        tppNames = tppNames.slice(0,3).join(', ');
        return tppNames;
    }

    buildTPPs(){
        const getLastTPPsActive = this.getLastTPPsActive();
        const title = formatText('profileKeysLanding-changeTPP');
        return (
            <ContentBox title={title} smallTitle={true} leftIcon={{'icon' : tppsIcon }} >
                <FormattedText value="profileKeysLanding-changeTPPDesc" className="keys-view__text"/>
                <div className="keys-view__button">
                    <OKLink
                        modifier="editorial"
                        to="/myprofile/keys/tpps"
                        onClick={() =>
                            recordLink(
                                TPPS_MANAGEMENT,
                                MANAGE_SECURITY,
                                SECURITY_PAGE_NAME
                            )
                        }
                    >
                        <FormattedText value="profileKeysLanding-manageTPPsButton" />
                    </OKLink>
                </div>
                {this.buildTPPsDesc(getLastTPPsActive)}
            </ContentBox>
        );
    }

    buildTPPsDesc(lastTPPs){
        const activeTPPs = formatText('profileKeysLanding-activeTPPs');
        return (lastTPPs &&
            <div className="row keys-view__security-kit">
                <div className="col-md-10">
                    <i className="keys-view__icon-padlock"/>
                    <span className="keys-view__label">
                        <span>{activeTPPs} {lastTPPs}</span>
                        <span></span>
                    </span>
                </div>
            </div>
        )
    }

    buildEcommerce = () => {
        const { immAccessKeyChange } = this.props;
        const title = formatText('eCommerceKeyLanding-title');
        return(
            <ContentBox title={title} smallTitle={true} leftIcon={{'icon': ecommerceIcon}}>
                <FormattedText value="eCommerceKeyLanding-description" className="keys-view__text"/>
                <div className="keys-view__button">
                    <OKLink
                        modifier="editorial"
                        to="/myprofile/keys/ecommerce"
                    >
                        <FormattedText value="eCommerceKeyLanding-manage" />
                    </OKLink>
                </div>
                {this.buildEcommerceLastChange(immAccessKeyChange.getIn(['cmcContract', 'keyEcommerceChange']))}
            </ContentBox>
        )
    }

    buildEcommerceLastChange(lastEcommerceKey){
        const lastEcommerceChange = formatText('eCommerceKeyLanding-lastChange');
        return (lastEcommerceKey &&
            <div className="row keys-view__security-kit">
                <div className="col-md-10">
                    <i className="keys-view__icon-clock"/>
                    <span className="keys-view__label">
                        <span>{lastEcommerceChange} {DateHelper.getOnlyDateFormatted(lastEcommerceKey)}</span>
                        <span></span>
                    </span>
                </div>
            </div>
        )
    }

    buildFooterKeys = () => {
        const { showFaqInformation } = this.props;

        return (
            <React.Fragment>
                <FormattedText
                    value={
                        showFaqInformation
                            ? "profileKeysLanding-sideText1"
                            : "profileKeysLanding-sideText1TitleFaqs"
                    }
                />{" "}
                {showFaqInformation ? (
                    <a
                        href={FAQ_URL}
                        className="contact-info-box__text--link"
                        target="_blank"
                        onClick={() =>
                            recordLink(SECURITY_PAGE_NAME, SECURITY_FAQS)
                        }
                    >
                        <FormattedText value="profileKeysLanding-sideText2" />
                    </a>
                ) : (
                    <FormattedText value="profileKeysLanding-sideText1ComingSoon" />
                )}
            </React.Fragment>
        );
    }

    render() {
        const {
            immAccessKeyChange,
            immTppFeatureFlag,
            isNerudaUser,
            showEcommerceKeyChange,
            showSessionsAndDevices,
        } = this.props;
        const titleHeader = formatText('profileKeysLanding-title');
        const changePasswordText = formatText('profileKeysLanding-changePassword');
        const changeKeyText = formatText('profileKeysLanding-changeKey');
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-profileKeySignatureTitle')}
            />
        );

        const boxTitle = formatText('profileKeysLanding-sideBoxHeader');
        const sideBoxBody01Value = isNerudaUser ? 'profileKeysLanding-profileKeysLanding_sideBoxBody01NerudaUser' : 'profileKeysLanding-sideBoxBody01';

        const boxBody = (
            <div>
                <div className="keys-view__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <ul className="contact-info-box__list">
                    {
                        showSessionsAndDevices &&
                        <li className="contact-info-box__list-item">
                            <FormattedText
                                className="contact-info-box__list-item-value"
                                value={sideBoxBody01Value}
                            />
                        </li>
                    }
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="profileKeysLanding-sideBoxBody02"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="profileKeysLanding-sideBoxBody03"
                        />
                    </li>
                </ul>
                <div className="keys-view__footer">
                    {this.buildFooterKeys()}
                </div>
            </div>
        );

        let tppSection;

        if (immTppFeatureFlag && !isNerudaUser){
            tppSection = (
                <div className="col-md-12 grid-view--fix-cell-separation">
                    {this.buildTPPs()}
                </div>
            );
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="pg" customClass="col-xs-12">
                            <OKHeaderLanding title={titleHeader}/>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-positive">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    {showEcommerceKeyChange &&
                                    <div className="col-md-12">
                                        {this.buildEcommerce()}
                                    </div>
                                    }
                                    {this.renderSessionAndDevices()}
                                    {tppSection}
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        {this.renderSecurityKit()}
                                    </div>
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        <ContentBox title={changePasswordText} tutorial={tutorial} smallTitle={true} leftIcon={{'icon' : accessKeyIcon}}>
                                            <FormattedText value="profileKeysLanding-changePasswordDesc" className="keys-view__text"/>
                                            <div className="keys-view__button">
                                                <OKLink
                                                    modifier="editorial"
                                                    to="/myprofile/keys/password"
                                                    onClick={() =>
                                                        recordLink(
                                                            PASSWORD,
                                                            MODIFY_SECURITY,
                                                            SECURITY_PAGE_NAME
                                                        )
                                                    }
                                                >
                                                    <FormattedText value="profileKeysLanding-changeButton" />
                                                </OKLink>
                                            </div>
                                            {this.renderAccessKey(immAccessKeyChange.getIn(['cmcContract', 'keyChange']))}
                                        </ContentBox>
                                    </div>
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        <ContentBox title={changeKeyText} tutorial={tutorial} smallTitle leftIcon={{'icon' : signatureKeyIcon}}>
                                            <FormattedText value="profileKeysLanding-changeKeyDesc" className="keys-view__text" />
                                            <div className="keys-view__button">
                                                <OKLink
                                                    modifier="editorial"
                                                    to="/myprofile/keys/signature"
                                                    onClick={() =>
                                                        recordLink(
                                                            SIGNATURE_PATTERN,
                                                            MODIFY_SECURITY,
                                                            SECURITY_PAGE_NAME
                                                        )
                                                    }
                                                >
                                                    <FormattedText value="profileKeysLanding-changeButton" />
                                                </OKLink>
                                            </div>
                                            {this.renderSignatureKey(immAccessKeyChange.getIn(['cmcContract', 'keySignature']))}
                                        </ContentBox>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-12 grid-view--variable-cell-separation">
                                        <WebappRender>
                                            <ContactInfoBox
                                                boxTitle={boxTitle}
                                                boxBody={boxBody}
                                                icon={infoIcon}
                                            />
                                        </WebappRender>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileKeysView.propTypes = {
    getKits: PropTypes.func.isRequired,
    immAccessKeyChange: PropTypes.object.isRequired,
    immMyProfileSecurityKitChange: PropTypes.object.isRequired,
    immTppFeatureFlag: PropTypes.bool,
    isNerudaUser: PropTypes.bool.isRequired,
    requestAccessKeyData: PropTypes.func.isRequired,
    requestDevices: PropTypes.func.isRequired,
    clearDevices: PropTypes.func.isRequired,
    device: PropTypes.object,
    showSecurityKit: PropTypes.bool,
    showSessionsAndDevices: PropTypes.bool,
    lastAccess: PropTypes.string,
    requestTppKeysData: PropTypes.func.isRequired,
    immProfileKeysTpps: PropTypes.object.isRequired,
    showFaqInformation: PropTypes.bool,
    showEcommerceKeyChange: PropTypes.bool,
    originCountry: PropTypes.object.isRequired
};

module.exports.constructor = MyProfileKeysView;
module.exports.MyProfileKeysView = connect(
    state => ({
        showEcommerceKeyChange: state.flagBasedFeatures.get(ECOMMERCE_KEY),
        showSessionsAndDevices: state.flagBasedFeatures.get('sec-sessions'),
        showSecurityKit: state.flagBasedFeatures.get('sec-kits'),
        showFaqInformation: state.flagBasedFeatures.get(FAQ),
        immAccessKeyChange: state.accessKeyChange,
        immMyProfileSecurityKitChange: state.myProfileSecurityKitChange,
        immTppFeatureFlag: state.flagBasedFeatures.get('tpps_enabled'),
        device: state.devices.get("devices").toJSON().length ? state.devices.get("devices").toJSON()[0] : null,
        isNerudaUser: state.profile.get('isNerudaUser'),
        lastAccess: state.accessKeyChange.getIn(['cmcContract', 'lastAccess']),
        immProfileKeysTpps: state.myProfileKeysTpps,
        originCountry: state.profile.get("originCountry"),
    }),
    {
        requestAccessKeyData: accessKeyChangeActions.requestAccessKeyData,
        requestTppKeysData: myProfileKeysTppsActions.requestTppKeysData,
        getKits,
        requestDevices,
        clearDevices
    }
)(MyProfileKeysView);
